import createRestfulModule from './restful-module'

export default createRestfulModule({

  state: {
    path: 'activity-pagesettings',
  }

})
